export default __webpack_public_path__ + "static/media/darkblue.309fec56.png";